import React, {useState, useEffect} from "react";
import {Icon, IconButton} from "@spg/component_library";
import copyIcon from "../images/copy.svg";
import {copyTextToClipboard} from "../logic/clipboard";

type CopyToClipboardProps = {
  /** A prefix for a unique HTML-ID */
  idBase: string;
  /** The string to write to the clipboard */
  text: string;
  /** The label for the button, e.g. "Copy name" */
  title: string;
  /** Any additional props to add to the IconButton */
  additionalButtonProps?: Omit<
    React.ComponentProps<typeof IconButton>,
    "idBase" | "onClick" | "iconProps"
  >;
  /** Any additional props to add to the iconProps of the IconButton */
  additionalIconProps?: Omit<
    React.ComponentProps<typeof Icon>,
    "href" | "iconColor" | "title"
  >;
};

/**
 * A component showing an IconButton that allows some text to be written to the clipboard.
 * TODO move to component library
 */
function CopyToClipboard(props: CopyToClipboardProps) {
  const [copyInfo, setCopyInfo] = useState<{
    timeoutId: ReturnType<typeof setTimeout>;
    state: "#failure" | "#success";
  }>();

  useEffect(
    () => () => {
      if (copyInfo) clearTimeout(copyInfo.timeoutId);
    },
    [],
  );

  return (
    <IconButton
      idBase={props.idBase + "CopyToClipboard"}
      onClick={() => {
        copyTextToClipboard(props.text).then(
          () =>
            setCopyInfo((ci) => {
              if (ci) clearTimeout(ci.timeoutId);
              return {
                state: "#success",
                timeoutId: setTimeout(() => setCopyInfo(undefined), 1000),
              };
            }),
          () =>
            setCopyInfo((ci) => {
              if (ci) clearTimeout(ci.timeoutId);
              return {
                state: "#failure",
                timeoutId: setTimeout(() => setCopyInfo(undefined), 1000),
              };
            }),
        );
      }}
      iconProps={{
        href: copyIcon + (copyInfo ? copyInfo.state : "#globalG"),
        strokeColor: "black",
        title: props.title,
        ...props.additionalIconProps,
      }}
      {...props.additionalButtonProps}
    />
  );
}

export {CopyToClipboard};
